import '../Admin/AdminDashboard.css';
import { useNavigate } from 'react-router-dom';

function QuizEditorDashboard() {
    const navigate = useNavigate();

    const tiles = [
        {
            id: 'create-quiz',
            title: 'Vytvořit kvíz',
            description: 'Sestavit nový kvíz z dostupných otázek',
            icon: '📝',
            path: '/editor-kvizu/create',
            color: '#e94560'
        },
        {
            id: 'manage-quizzes',
            title: 'Spravovat kvízy',
            description: 'Upravit nebo smazat existující kvízy',
            icon: '📋',
            path: '/editor-kvizu/manage',
            color: '#4CAF50'
        }
    ];

    const handleTileClick = (tile) => {
        navigate(tile.path);
    };

    return (
        <div className="admin-dashboard-page">
            <div className="admin-dashboard-container">
                <h1 className="page-title">Editor kvízů</h1>
                <p className="page-subtitle">Vyberte akci, kterou chcete provést</p>

                <div className="admin-tiles-grid">
                    {tiles.map(tile => (
                        <div
                            key={tile.id}
                            className="admin-tile"
                            onClick={() => handleTileClick(tile)}
                            style={{
                                '--tile-color': tile.color
                            }}
                        >
                            <div className="tile-icon">{tile.icon}</div>
                            <h2 className="tile-title">{tile.title}</h2>
                            <p className="tile-description">{tile.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default QuizEditorDashboard;
